import React from 'react';
import icon from '@web-common/components/UI/Icons/svgs';
const { HtmlIcon, ImageIcon, JsonIcon, MarkdownIcon, Mp3Icon, Mp4Icon, OtherIcon, PdfIcon, PPTIcon, PSIcon, TxtIcon, WordIcon, XlsIcon, UploadErrorIcon, DownloadIcon, UploadIcon, MoreIcon, ZipIcon, SaveIcon, NextIcon, PreviousIcon, OpenIcon, CloseIcon, DoUploadIcon, DoDownloadIcon, PrivateDiskIcon, Search, PublickDisk, RecentlyIcon, Share, DiskUpload, ArrowRight, Folder, RecycleBin, Info, AddFolder, CloseCircle, BoldUploadIcon, BoldDownloadIcon, UpTriangle, LeftTriangle, DownTriangle, CreateIcon, LxXlsIcon, LxDocIcon, LxUnitableIcon, BackArrowIcon, SavedIcon, HistoryIcon, ExportIcon, MoveToIcon, HomePageIcon, SharePageIcon, RenameFile, EmlIcon, WarnYellow, } = icon;
export const iconMap = {
    closeCircle: CloseCircle,
    diskUpload: DiskUpload,
    addFolder: AddFolder,
    arrowRight: ArrowRight,
    folder: Folder,
    dir: Folder,
    recycleBin: RecycleBin,
    renameFile: RenameFile,
    info: Info,
    share: Share,
    publicDisk: PublickDisk,
    search: Search,
    privateDisk: PrivateDiskIcon,
    recently: RecentlyIcon,
    homepage: HomePageIcon,
    sharePage: SharePageIcon,
    zip: ZipIcon,
    rar: ZipIcon,
    html: HtmlIcon,
    jpg: ImageIcon,
    JPG: ImageIcon,
    jpeg: ImageIcon,
    JPEG: ImageIcon,
    png: ImageIcon,
    PNG: ImageIcon,
    svg: ImageIcon,
    json: JsonIcon,
    md: MarkdownIcon,
    mp3: Mp3Icon,
    wav: Mp3Icon,
    mp4: Mp4Icon,
    mov: Mp4Icon,
    MOV: Mp4Icon,
    pdf: PdfIcon,
    ppt: PPTIcon,
    pptx: PPTIcon,
    ps: PSIcon,
    txt: TxtIcon,
    word: WordIcon,
    doc: WordIcon,
    docx: WordIcon,
    xls: XlsIcon,
    xlsx: XlsIcon,
    other: OtherIcon,
    error: UploadErrorIcon,
    download: DownloadIcon,
    upload: UploadIcon,
    more: MoreIcon,
    save: SaveIcon,
    next: NextIcon,
    previous: PreviousIcon,
    open: OpenIcon,
    close: CloseIcon,
    doUpload: DoUploadIcon,
    doDownload: DoDownloadIcon,
    boldUpload: BoldUploadIcon,
    boldDownload: BoldDownloadIcon,
    upTriangle: UpTriangle,
    downTriangle: DownTriangle,
    leftTriangle: LeftTriangle,
    create: CreateIcon,
    lxxls: LxXlsIcon,
    lxdoc: LxDocIcon,
    lxunitable: LxUnitableIcon,
    backArrow: BackArrowIcon,
    saved: SavedIcon,
    history: HistoryIcon,
    export: ExportIcon,
    moveTo: MoveToIcon,
    eml: EmlIcon,
    warnYellow: WarnYellow,
};
const IconCard = (props) => {
    const Icon = iconMap[props.type] || iconMap.other;
    return React.createElement(Icon, Object.assign({}, props));
};
export default IconCard;
